import { PHASE } from "../../../../common/constants.ts";
import getWinner from "../../../../common/getWinner.ts";
import type { HeadToHead } from "../../../../common/types.ts";
import { idb } from "../../db/index.ts";
import { g } from "../../util/index.ts";

const addGame = async ({
	tids,
	pts,
	sPts,
	overtime,
	season = g.get("season"),
	playoffs = g.get("phase") === PHASE.PLAYOFFS,
}: {
	tids: [number, number];
	pts: [number, number];
	sPts: [number, number] | undefined;
	overtime: boolean;
	season?: number;
	playoffs?: boolean;
}) => {
	// Playoffs head-to-head was only read by the deleted h2h views; only the
	// regularSeason records feed the headToHeadRecord tiebreaker.
	if (playoffs) {
		return;
	}

	const otl = g.get("otl", season);

	const headToHead: HeadToHead = (await idb.cache.headToHeads.get(season)) ?? {
		season,
		regularSeason: {},
		playoffs: {},
	};

	const minTid = Math.min(...tids);
	const i = tids.indexOf(minTid) as 0 | 1;
	const j = i === 0 ? 1 : 0;
	const t0 = tids[i];
	const t1 = tids[j];

	// All-Star Game
	if (t0 < 0 || t1 < 0) {
		return;
	}

	const winner = getWinner([
		{
			pts: pts[i],
			sPts: sPts?.[i],
		},
		{
			pts: pts[j],
			sPts: sPts?.[j],
		},
	]);

	if (!headToHead.regularSeason[t0]) {
		headToHead.regularSeason[t0] = {};
	}

	if (!headToHead.regularSeason[t0][t1]) {
		headToHead.regularSeason[t0][t1] = {
			won: 0,
			lost: 0,
			tied: 0,
			otl: 0,
			otw: 0,
			pts: 0,
			oppPts: 0,
		};
	}

	if (winner === 0) {
		if (overtime && otl) {
			headToHead.regularSeason[t0][t1].otw += 1;
		} else {
			headToHead.regularSeason[t0][t1].won += 1;
		}
	} else if (winner === -1) {
		headToHead.regularSeason[t0][t1].tied += 1;
	} else {
		if (overtime && otl) {
			headToHead.regularSeason[t0][t1].otl += 1;
		} else {
			headToHead.regularSeason[t0][t1].lost += 1;
		}
	}

	headToHead.regularSeason[t0][t1].pts += pts[i];
	headToHead.regularSeason[t0][t1].oppPts += pts[j];

	await idb.cache.headToHeads.put(headToHead);
};

export default addGame;
